import assign from "lodash.assign";
import { LOCATION_CHANGE } from "react-router-redux";
import User from "../services/User";
import loginRegister from "./loginRegister";
import { setErrorInErrors, clearErrorFromErrors } from "../utils/errorsUtil";
import REDUX_ERROR_TYPES from "constants/ReduxErrorTypes";

// Actions (must be name-spaced for reducer)

export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_SET_ERROR = "FORGOT_PASSWORD_SET_ERROR";
export const FORGOT_PASSWORD_CLEAR_ERROR = "FORGOT_PASSWORD_CLEAR_ERROR";

// Reducer

export function forgotPasswordReducer(state = { errors: {} }, action) {
    switch (action.type) {
        case LOCATION_CHANGE:
            return { errors: {} };
        case FORGOT_PASSWORD_SUCCESS:
            return assign({}, state, {
                success: action.success
            });
        case FORGOT_PASSWORD_SET_ERROR:
            return assign({}, state, {
                errors: setErrorInErrors(state.errors, action.error),
                success: null
            });
        case FORGOT_PASSWORD_CLEAR_ERROR:
            return assign({}, state, {
                errors: clearErrorFromErrors(state.errors, action.errorType)
            });
        default:
            return state;
    }
}

// Action Creators

export function forgotPassword(email, redirectUrl = "", captcha) {
    return (dispatch) => {
        dispatch(clearError(REDUX_ERROR_TYPES.FORGOT_PASSWORD));

        return User.forgotPassword(email, redirectUrl, captcha)
            .then(({ successMessage }) => {
                dispatch(showSuccess({
                    type: REDUX_ERROR_TYPES.FORGOT_PASSWORD,
                    message: successMessage
                }));
            })
            .catch((error) => {
                switch (error.status) {
                    case 429:
                        dispatch(loginRegister.showRecaptcha(true));
                        break;
                    default:
                        dispatch(showError({
                            type: REDUX_ERROR_TYPES.FORGOT_PASSWORD,
                            message: error.errorMessage
                        }));
                        break;
                }

                throw error;
            });
    };
}

export function showSuccess(success) {
    return {
        type: FORGOT_PASSWORD_SUCCESS,
        success
    };
}

export function showError(error) {
    return {
        type: FORGOT_PASSWORD_SET_ERROR,
        error
    };
}

export function clearError(errorType) {
    return {
        type: FORGOT_PASSWORD_CLEAR_ERROR,
        errorType
    };
}

export default {
    forgotPasswordReducer,
    forgotPassword,
    showError,
    clearError,
    showSuccess
};
